export * from './doc'
export * from './img'
export * from './note'
export * from './sysconfig'
export * from './publishNote'
export * from "./folder"
export * from "./pageCache"
export * from "./fontInfo"
export * from "./card"
export * from "./tag"
export * from "./highlight"
export * from "./libraryHistory"
export * from "./projectHistory"
export * from "./board"
export * from "./cardLinkCache"
export * from "./customFilter"
export * from "./FavorFolder"
export * from "./projectContentFilter"
export * from "./link"
export * from "./Property"
export * from "./view"
export * from "./webHistory"
export * from "./transcript"
export * from "./tiptapDoc"
export * from "./template"

import { delDoc } from './doc'
import { delImg } from './img'
import { delNote } from './note'

export function deleteNote(id){
    delDoc(id)
    delNote(id)
    delImg(id)
}